import { render, staticRenderFns } from "./SizeChartsList.vue?vue&type=template&id=a1f76508&scoped=true"
import script from "./SizeChartsList.vue?vue&type=script&lang=js"
export * from "./SizeChartsList.vue?vue&type=script&lang=js"
import style0 from "./SizeChartsList.vue?vue&type=style&index=0&id=a1f76508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f76508",
  null
  
)

export default component.exports